import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { isMobileFilter } from 'swag-client-common/utils/ui.utils';
import classes from './brands.scss';
import animationClasses from './brands.anim.scss';
const logosArrDesktop = ['logos1', 'logos2', 'logos3', 'logos4'];
const logosArrMobile = ['brandsMob1', 'brandsMob2', 'brandsMob3', 'brandsMob4', 'brandsMob5', 'brandsMob6', 'brandsMob7', 'brandsMob8'];
const time = 6000;
export default function Brands({
  additionalClassName,
  additionalBlueTextClassName
}) {
  const [index, setIndex] = useState(0);
  const isMobileView = isMobileFilter();
  const logosArr = isMobileView ? logosArrMobile : logosArrDesktop;
  const logosSrc = logosArr[index];
  const play = () => {
    const next = index + 1;
    if (!logosArr[next]) {
      setIndex(0);
    } else {
      setIndex(next);
    }
  };
  useEffect(() => {
    const timer = setTimeout(play, time);
    return () => clearTimeout(timer);
  }, [index]);
  useEffect(() => {
    setIndex(0);
  }, [isMobileView]);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(additionalClassName, classes.brands)
  }, /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.blueText, additionalBlueTextClassName)
  }, "Trusted by 1000's of companies:", ' '), /*#__PURE__*/React.createElement("div", {
    className: classes.imageWrapper
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    key: logosSrc,
    timeout: 500
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.brandsImage, classes[logosSrc])
  })))));
}